import React from 'react';

const HandlerContext = React.createContext({});

export default HandlerContext;
